const UserMode = {
  MINE: 'MINE',
  MY_HIERARCHY: 'MY_HIERARCHY'
};

export default UserMode;
